import baseApi from '@/helpers/baseApi';
import { ISharedRender } from '@/helpers/interfaces/sharedTemplates.interface';
import { ITemplateRenderData } from './templatesApi';

const apiUrl = process.env.API_URL;

const sharedTemplatesApi = {
  getSeoTemplateByID: (id: string) => baseApi.get(`${apiUrl}/sharedtemplatespublic/${id}`),
  getSeoTemplateContent: (id: string) => baseApi.get(`${apiUrl}/sharedtemplatespublic/${id}/content`),
  getSeoTemplateSides: (id: string) => baseApi.get(`${apiUrl}/sharedtemplatespublic/${id}/sides`),
  getSeoTemplatePreviews: (id: string) => baseApi.get(`${apiUrl}/sharedtemplatespublic/${id}/previews`),
  getSharedTemplates: () => baseApi.get(`${apiUrl}/sharedtemplatespublic`),

  sendDataToEmail: (id: string, mail: string) => baseApi.post(`${apiUrl}/sharedrenderspublic/${id}/send`, mail),
  renderTemplateFromSeo: (id: string, data: ITemplateRenderData) =>
    baseApi.post<ISharedRender, ITemplateRenderData>(`${apiUrl}/sharedtemplatespublic/${id}/createrender`, data),
  sendToRenderDocument: (idTemplate: string, idDocument: string, type: string) => baseApi
    .get(`${apiUrl}/sharedtemplatespublic/${idTemplate}/render/${idDocument}?format=${type}`, { responseType: 'blob' }),

  copySharedTemplate: ({ id, ...data }: { id: string, folderid: string }) =>
    baseApi.post<{ id: string, translatedName: string }, { folderid: string }>(`${apiUrl}/sharedtemplates/${id}/copy`, data),
};

export default sharedTemplatesApi;
